import { cn } from "@/lib/utils";

// Real Zentara Z mark (gold-on-black, from brand assets)
export function ZentaraMark({ size = 44, className }) {
  return (
    <img
      src="/zentara-logo.png"
      alt="Zentara"
      width={size}
      height={size}
      className={cn("rounded-md", className)}
      style={{ width: size, height: size, objectFit: "contain" }}
    />
  );
}

export function ZentaraLogo({ compact = false, markSize = 44, productName = "Redline" }) {
  return (
    <div className="flex items-center gap-3">
      <ZentaraMark size={markSize} />
      {!compact && (
        <div className="leading-tight">
          <div className="font-heading text-lg font-bold tracking-tight text-[#f7f3ec]">
            Zentara <span className="text-[#c5a24a]">{productName}</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-[#9a9285]">
            As-Built &amp; Engineering Group Ltd
          </div>
        </div>
      )}
    </div>
  );
}
